/*
 OK FBI — Evidence Media Enrichment Map
 Maps [case_id][evidence_id] → { media_type, ...payload }.
 Zero backend changes required. The EvidenceViewer reads this and renders the
 appropriate cinematic interactive interface.

 Media types supported:
   photo          — cinematic close-up crime-scene photograph with evidence markers
   cctv_clip      — single CCTV clip with chrome, scrub-bar, keyframes
   audio          — waveform player with procedural / TTS playback + transcript
   phone_call     — call metadata + dialogue lines (per-line TTS)
   voicemail      — one-way voice message + waveform + transcript
   document       — readable formal document (letterhead, body, signatures)
   phone_forensics — recovered phone with tabs (calls / messages / photos / notes / location / deleted)
*/

// ============ CASE-001 · الطابق 13 ============
const CASE_001 = {
  "EV-01": {
    media_type: "photo",
    caption: "زجاجة ماء منتصف الطاولة الجانبية — الجناح 1307",
    scene: "hotel_suite",
    markers: [
      { x: 52, y: 55, id: "01", label: "الزجاجة" },
      { x: 40, y: 60, id: "02", label: "غطاء مفكوك" },
    ],
    details: [
      { k: "الموقع", v: "منضدة جانبية · الجناح 1307" },
      { k: "الوقت", v: "02:22 ص · جمع الأدلة" },
      { k: "الحالة", v: "نصف فارغة · سائل رائق · بدون رائحة" },
      { k: "أدوات مقترحة", v: "سموم · بصمات" },
    ],
    analysis_hint: "قد تحتوي على أثر مادة كيميائية.",
  },
  "EV-02": {
    media_type: "photo",
    caption: "بصمة إبهام كاملة على مقبض الباب الداخلي",
    scene: "door_handle",
    markers: [ { x: 58, y: 42, id: "01", label: "البصمة" } ],
    details: [
      { k: "الموقع", v: "مقبض داخلي · باب الجناح 1307" },
      { k: "طريقة الرفع", v: "مسحوق أسود مغناطيسي" },
      { k: "الجودة", v: "واضحة — 96% صالحة للمقارنة" },
      { k: "أدوات مقترحة", v: "بصمات" },
    ],
    analysis_hint: "بصمة صالحة للتطابق المباشر مع قاعدة الفندق.",
  },
  "EV-03": {
    media_type: "cctv_clip",
    camera_id: "CAM-01",
    camera_label: "ممر الطابق 13",
    date: "12 مايو 2024",
    time_start: "02:09 ص",
    time_end: "02:19 ص",
    duration_sec: 600,
    scene: "hotel_corridor",
    keyframes: [
      { at: 5,   label: "حركة قرب باب الجناح 1305" },
      { at: 122, label: "الإضاءة تخفت للحظات" },
      { at: 155, label: "انقطاع الصورة (يدوي)" },
      { at: 480, label: "عودة الصورة — الممر فارغ" },
    ],
    note: "الانقطاع بين 02:11 و 02:17 — لا يتطابق مع أي عطل معروف في نظام الكاميرات.",
  },
  "EV-04": {
    media_type: "phone_forensics",
    device_label: "هاتف الضحية · iPhone Pro",
    imei: "358***********",
    unlocked_at: "02:34 ص · معمل الطب الشرعي",
    tabs: {
      messages: [
        { from: "رقم مجهول", to: "الضحية", at: "قبل يومين · 08:12 م",
          body: "لا تتذاكى معي. ما وعدتك به لم يتغيّر.", flagged: true },
        { from: "الضحية", to: "رقم مجهول", at: "قبل يومين · 08:15 م",
          body: "لا تتصل بي مرة أخرى. أعرف من أنت." },
      ],
    },
    hint: "الرمز الدولي للرقم المجهول يطابق رقم ليان.",
  },
  "EV-05": {
    media_type: "document",
    doc_title: "سجل الدخول الإلكتروني — بطاقة صيانة SVC-A17",
    doc_subtitle: "Royal View Hotel · قسم الأمن",
    rows: [
      { time: "01:26 ص", door: "غرفة المولد · الطابق -1", card: "SVC-A17", note: "دخول" },
      { time: "01:33 ص", door: "غرفة الكهرباء · B-Wing",  card: "SVC-A17", note: "دخول" },
      { time: "01:38 ص", door: "المصعد الخلفي · طابق 13", card: "SVC-A17", note: "استخدام" },
      { time: "01:41 ص", door: "الجناح 1307 · مدخل رئيسي", card: "SVC-A17", note: "**فتح — 3 ثوانٍ**", flag: true },
      { time: "02:19 ص", door: "غرفة الكهرباء · B-Wing",  card: "SVC-A17", note: "دخول" },
    ],
    footer: "بطاقة SVC-A17 مسجّلة كـ (صيانة عامة) — ليست مخصصة لموظف بعينه.",
  },
  "EV-06": {
    media_type: "cctv_clip",
    camera_id: "CAM-02",
    camera_label: "المصعد الرئيسي · صعود",
    date: "12 مايو 2024",
    time_start: "02:08 ص",
    time_end: "02:11 ص",
    duration_sec: 180,
    scene: "elevator",
    keyframes: [
      { at: 14, label: "دخول شخص بزي صيانة" },
      { at: 32, label: "الوجه بعيد عن الكاميرا" },
      { at: 78, label: "الوقوف عند طابق 13" },
    ],
    note: "بنية الجسم والطول يطابقان RVH-008 · الوجه غير واضح.",
  },
  "EV-07": {
    media_type: "photo",
    caption: "قاطع الكهرباء الرئيسي — قسم B",
    scene: "electrical_panel",
    markers: [
      { x: 48, y: 38, id: "01", label: "القاطع المفصول" },
      { x: 51, y: 42, id: "02", label: "أثر يد" },
    ],
    details: [
      { k: "الموقع", v: "غرفة الكهرباء · B-Wing" },
      { k: "الحالة", v: "فُصل يدوياً 02:11 · أُعيد 02:19" },
      { k: "أدوات مقترحة", v: "بصمات · مواد" },
    ],
    analysis_hint: "بصمات حديثة على المقبض تدل على تحكم يدوي.",
  },
  "EV-08": {
    media_type: "document",
    doc_title: "مسودة وصية جديدة — Draft v3",
    doc_subtitle: "خاص · لم يُوقّع بعد",
    rows: [
      { time: "بند 1", door: "الحصص الرئيسية للفندق", card: "—", note: "تعود إلى الابنة (خارج القضية)" },
      { time: "بند 2", door: "حصص السلاسل الفرعية",   card: "—", note: "تُوزَّع على شريكين تجاريين" },
      { time: "بند 3", door: "المتبنّى RVH-006",       card: "—", note: "**يُحذف كلياً من الإرث**", flag: true },
      { time: "بند 4", door: "التبرعات",              card: "—", note: "تُوجَّه لجمعية خيرية" },
    ],
    footer: "آخر تعديل قبل الحادثة بـ 40 دقيقة · محفوظ محلياً على حاسوب الضحية.",
  },
  "EV-09": {
    media_type: "photo",
    caption: "قنينة دواء مهدئ فارغة — سلة قمامة المطبخ",
    scene: "kitchen_medbottle",
    markers: [ { x: 44, y: 60, id: "01", label: "القنينة" } ],
    details: [
      { k: "الوصفة", v: "Midazolam 15mg/ml · مقيّد الصرف" },
      { k: "المصدر", v: "صيدلية الفندق — سجل الصرف مفقود" },
      { k: "أدوات مقترحة", v: "سموم · بصمات · مواد" },
    ],
    analysis_hint: "المادة نفسها المكتشفة في زجاجة الماء.",
  },
  "EV-10": {
    media_type: "phone_forensics",
    device_label: "هاتف الضحية · iPhone Pro (سجل مكالمات)",
    imei: "358***********",
    unlocked_at: "02:34 ص",
    tabs: {
      calls: [
        { name: "خالد",       type: "صادرة", at: "12:20 ص", duration: "42 ث", flagged: true },
        { name: "رقم مجهول", type: "واردة", at: "01:14 ص", duration: "1 د 12 ث" },
        { name: "غرفة الأمن", type: "صادرة", at: "01:52 ص", duration: "9 ث" },
      ],
    },
    hint: "خالد لم يذكر مكالمة الساعة 12:20.",
  },
  "EV-11": {
    media_type: "phone_forensics",
    device_label: "هاتف ليان · محذوف — استُرجع",
    imei: "murky",
    unlocked_at: "03:11 ص",
    tabs: {
      deleted: [
        { at: "قبل 3 أيام", body: "لا تعيد لي حصصي بشكل جزئي. إما كاملة وإما مواجهة قانونية." },
        { at: "قبل يومين",  body: "أخبرني بشكل واضح: هل ستسحب حصتي أم لا؟" },
        { at: "أمس",       body: "لن أنتظر أكثر. أعرف من يفكّر بالفندق ضدك." },
      ],
    },
    hint: "الرسائل تكشف نية سحب حصص ليان بالكامل.",
  },
  "EV-12": {
    media_type: "photo",
    caption: "خصلة شعر على الوسادة الجانبية",
    scene: "pillow_hair",
    markers: [ { x: 52, y: 47, id: "01", label: "الخصلة" } ],
    details: [
      { k: "المصدر", v: "وسادة يسار الضحية" },
      { k: "الأدوات", v: "DNA" },
    ],
    analysis_hint: "قابل للتطابق مع عينات المشتبه بهم.",
  },
  "EV-13": {
    media_type: "photo",
    caption: "أثر حذاء طيني على درجة سلم السطح",
    scene: "roof_stairs",
    markers: [ { x: 46, y: 62, id: "01", label: "أثر الحذاء" } ],
    details: [
      { k: "المقاس", v: "43 EU · نعل رياضي" },
      { k: "الأدوات", v: "مقارنة الأحذية · مواد" },
    ],
  },
  "EV-14": {
    media_type: "document",
    doc_title: "إيصال تحويل مالي — دانا (المتحدث الرسمي)",
    doc_subtitle: "شركة Cartel Realty · اليوم قبل الحادثة",
    rows: [
      { time: "المبلغ",  door: "45,000 ريال", card: "USD", note: "تحويل بنكي مشفّر" },
      { time: "الغاية",  door: "استشارة تسويقية",  card: "—", note: "مقابل تقرير تسويقي" },
      { time: "الملاحظة",door: "لا علاقة بالجريمة", card: "—", note: "شركة عقارية منافسة — سياق مختلف", flag: true },
    ],
    footer: "يبدو مريباً — لكن مسار الدفع مشروع.",
  },
  "EV-15": {
    media_type: "audio",
    label: "تسجيل صوت العشاء — CAM-06 (صوت فقط)",
    duration_sec: 22,
    waveform_seed: 501,
    voice: { rate: 1.0, pitch: 0.95 },
    transcript_lines: [
      { s: 1,  t: "الضحية: ليان، أنا صريح معك — الشراكة لا تكمل هكذا." },
      { s: 5,  t: "ليان: تعرف كم عملت لأصل هنا. لا تسحب حصتي." },
      { s: 10, t: "الضحية: القرار اتُّخذ. سأخبر يوسف الليلة." },
      { s: 15, t: "[صوت شاب في الخلفية: 'أنا هنا فعلاً']" },
      { s: 19, t: "ليان: مَن يجلس خلف السّتار؟" },
    ],
    hint: "الصوت الثالث في الخلفية — يوسف — رغم ادعائه أنه خارج الفندق.",
  },
  "EV-16": {
    media_type: "document",
    doc_title: "سجل خدمة الغرف — الطلب 4471",
    doc_subtitle: "Royal View · قسم الغرف",
    rows: [
      { time: "01:38 ص", door: "طلب واصل",           card: "الجناح 1307", note: "زجاجة ماء بارد" },
      { time: "01:41 ص", door: "استلام من الشيف سامي", card: "SF-01",     note: "معدّ في المطبخ الرئيسي" },
      { time: "01:45 ص", door: "توصيل شخصي",         card: "SF-01",     note: "وصل الجناح · لم يُصوَّر داخلياً", flag: true },
    ],
    footer: "خط الوصول من المطبخ إلى الجناح لا يمرّ بأي كاميرا داخلية.",
  },
  "EV-17": {
    media_type: "cctv_clip",
    camera_id: "CAM-04",
    camera_label: "مدخل الخدمة الخلفي",
    date: "12 مايو 2024",
    time_start: "12:03 ص",
    time_end: "12:08 ص",
    duration_sec: 300,
    scene: "back_entrance",
    keyframes: [
      { at: 62, label: "شاب يقترب من الباب" },
      { at: 90, label: "الوجه واضح · شاب في العشرينات" },
      { at: 121, label: "يدخل عبر الباب دون تصريح ظاهر" },
    ],
    note: "الوجه واضح تماماً — RVH-006 (يوسف).",
  },
  "EV-18": {
    media_type: "photo",
    caption: "قفازات بلاستيكية شفّافة — سلة قمامة المطبخ",
    scene: "gloves_bin",
    markers: [ { x: 50, y: 55, id: "01", label: "القفازات" } ],
    details: [
      { k: "الحالة",   v: "أثر سائل — سائل واضح" },
      { k: "الأدوات",  v: "مواد · سموم" },
    ],
    analysis_hint: "الأثر يطابق الماء المسموم.",
  },
  "EV-19": {
    media_type: "document",
    doc_title: "ملاحظة مكتوبة بخط اليد",
    doc_subtitle: "وُجدت مطويّة في جيب صدر الضحية",
    rows: [
      { time: "—", door: "«قابلني الليلة، سنحل هذا.»", card: "—", note: "مكتوبة بخط عربي مائل", flag: true },
      { time: "—", door: "بلا توقيع",                 card: "—", note: "لكن خط اليد يطابق RVH-006 (يوسف)" },
    ],
    footer: "خط اليد مطابق بنسبة عالية بعد المقارنة مع مسودات سابقة.",
  },
  "EV-20": {
    media_type: "phone_forensics",
    device_label: "هاتف يوسف · Android — بيانات GPS",
    imei: "358***********",
    unlocked_at: "معمل الطب الشرعي",
    tabs: {
      location: [
        { at: "11:44 م", where: "الحي السكني · شمال المدينة" },
        { at: "11:58 م", where: "شارع الملك عبدالله (متحرك)" },
        { at: "12:05 ص", where: "**Royal View Hotel — مدخل الخدمة**", flagged: true },
        { at: "01:22 ص", where: "الطابق 13 (تقريباً)" },
        { at: "02:12 ص", where: "الطابق 13 (داخل الجناح 1307)", flagged: true },
        { at: "02:24 ص", where: "درج الطوارئ · السطح" },
      ],
    },
    hint: "الهاتف داخل الفندق من 12:05 حتى بعد لحظة الوفاة — عكس ادعاء يوسف.",
  },
};

// ============ CASE-002 (تجارية) ============
const CASE_002 = {
  "EV-01": { media_type: "photo", caption: "دليل مادي من مسرح القضية 2", scene: "generic_forensic",
             markers: [{x:50,y:55,id:"01",label:"العينة"}],
             details: [{k:"الموقع",v:"مسرح الحادث"},{k:"أدوات",v:"بصمات · مواد"}] },
  "EV-02": { media_type: "photo", caption: "أثر بيولوجي — عيّنة مركّزة", scene: "generic_forensic",
             markers: [{x:52,y:48,id:"01",label:"الأثر"}],
             details: [{k:"أدوات",v:"DNA · بصمات"}] },
  "EV-03": { media_type: "cctv_clip", camera_id:"CAM-A", camera_label:"مدخل المكتب الرئيسي",
             date:"—", time_start:"11:12 م", time_end:"11:38 م", duration_sec: 1560, scene:"office",
             keyframes:[{at:120,label:"دخول شخص وحيد"},{at:445,label:"محادثة قصيرة"},{at:1000,label:"خروج مسرع"}],
             note:"لا توجد إضاءة في الردهة أثناء الخروج." },
  "EV-04": { media_type: "document", doc_title:"عقد شراكة", doc_subtitle:"شركة MSG",
             rows:[{time:"البند 3",door:"تقسيم الأرباح",card:"—",note:"غير عادل بشكل واضح", flag:true}],
             footer:"العقد موقّع مع تحفظ." },
  "EV-05": { media_type: "audio", label:"تسجيل اجتماع مغلق", duration_sec:18, waveform_seed:222,
             voice:{rate:1.0,pitch:0.9},
             transcript_lines:[
               {s:1,t:"مدير 1: هذا العرض غير مقبول."},
               {s:6,t:"مدير 2: إذا لم توقّع، ستحدث مشاكل."},
               {s:12,t:"[صمت طويل]"},
             ], hint:"تهديد ضمني قبل الحادثة بيوم." },
  "EV-06": { media_type: "phone_call", caller:"شريك تجاري", receiver:"الضحية", at:"11:52 م", duration:"38 ث",
             recovered:true, waveform_seed:733, voice:{rate:0.95,pitch:0.9},
             dialogue:[
               {speaker:"الشريك", t:"أين وعدك؟ ما أطول صبري."},
               {speaker:"الضحية", t:"أعطني حتى الغد. سأحسم كل شيء."},
               {speaker:"الشريك", t:"لا وقت للغد. الآن."},
             ], hint:"ضغط مفاجئ في وقت متأخر." },
};

// ============ CASE-003 (طبية) ============
const CASE_003 = {
  "EV-01": { media_type: "document", doc_title:"سجل صرف الأدوية", doc_subtitle:"مستشفى المصدر",
             rows:[
               {time:"08:14 ص",door:"دواء A · 20mg",card:"صيدلية 1",note:"صرف عادي"},
               {time:"08:19 ص",door:"دواء A · جرعة إضافية",card:"غير مسجّل",note:"**صرف بدون توقيع**",flag:true},
             ], footer:"الجرعة الإضافية لا تظهر في سجل الطبيب المسؤول." },
  "EV-02": { media_type: "photo", caption:"أنبوب دواء فارغ — رفّ الغرفة", scene:"med_vial",
             markers:[{x:48,y:55,id:"01",label:"الأنبوب"}],
             details:[{k:"الأدوات",v:"سموم · بصمات"}] },
  "EV-03": { media_type: "audio", label:"جهاز المراقبة — تنبيه", duration_sec:14, waveform_seed:99,
             voice:{rate:0.98,pitch:0.92},
             transcript_lines:[
               {s:1,t:"[نبضات غير منتظمة]"},
               {s:6,t:"[تنبيه: ضغط منخفض]"},
               {s:10,t:"[صمت — 4 ثوانٍ]"},
             ], hint:"التنبيهات تسبق الوفاة بأربع دقائق فقط." },
  "EV-04": { media_type: "cctv_clip", camera_id:"MRD-02", camera_label:"ممر جناح المرضى",
             date:"—", time_start:"03:41 ص", time_end:"03:56 ص", duration_sec:900,
             scene:"hospital_corridor",
             keyframes:[{at:80,label:"دخول شخص بزي طبي"},{at:340,label:"يغادر الغرفة سريعاً"}],
             note:"لم يكن هناك جولة تمريض مجدولة في هذا التوقيت." },
  "EV-05": { media_type: "phone_forensics", device_label:"هاتف الضحية · Samsung",
             imei:"357***********", unlocked_at:"04:20 ص",
             tabs:{ messages:[
               {from:"طبيب",to:"الضحية",at:"قبل 3 أيام",body:"سنستدعيك للمراجعة.",flagged:false},
               {from:"رقم داخلي",to:"الضحية",at:"قبل ساعة",body:"لا تخبر أحداً بما رأيت.",flagged:true},
             ]}, hint:"تهديد صادر من رقم داخل المستشفى." },
};

// ============ CASE-004 (طرود) ============
const CASE_004 = {
  "EV-01": { media_type: "photo", caption:"طرد مفتوح — مسرح التسليم", scene:"parcel_box",
             markers:[{x:50,y:52,id:"01",label:"الطرد"},{x:44,y:60,id:"02",label:"محتويات مبعثرة"}],
             details:[{k:"الأدوات",v:"بصمات · مواد"}] },
  "EV-02": { media_type: "cctv_clip", camera_id:"TRN-A", camera_label:"مركز الفرز الرئيسي",
             date:"—", time_start:"05:14 ص", time_end:"05:28 ص", duration_sec:840, scene:"warehouse",
             keyframes:[{at:64,label:"عامل يستبدل الملصق"},{at:200,label:"إعادة توجيه الطرد"}],
             note:"عملية تبديل ملصق سريعة — تحتاج معرفة داخلية." },
  "EV-03": { media_type: "document", doc_title:"بيان شحن — الملصق البديل", doc_subtitle:"شبكة TRN",
             rows:[{time:"—",door:"العنوان الأصلي",card:"شمال",note:"الوجهة الحقيقية"},
                   {time:"—",door:"العنوان المزيّف",card:"جنوب",note:"**كتب بخط يدوي فوق الأصلي**",flag:true}],
             footer:"الخط يطابق أحد الموظفين." },
  "EV-04": { media_type: "phone_call", caller:"موظف داخلي", receiver:"طرف خارجي", at:"04:58 ص",
             duration:"52 ث", recovered:true, waveform_seed:611, voice:{rate:1.0,pitch:0.88},
             dialogue:[
               {speaker:"الموظف", t:"الشحنة داخل الفرز الآن."},
               {speaker:"الطرف",  t:"استبدل الملصق قبل الخمسة والنصف."},
               {speaker:"الموظف", t:"تمام. لا شهود."},
             ], hint:"تنسيق مسبق قبل الحادثة بربع ساعة." },
};

// ============ CASE-005 (فيلا) ============
const CASE_005 = {
  "EV-01": { media_type: "photo", caption:"تحفة مسروقة — أثر إزاحة", scene:"villa_shelf",
             markers:[{x:48,y:44,id:"01",label:"مكان التحفة"},{x:44,y:52,id:"02",label:"بصمة"}],
             details:[{k:"الأدوات",v:"بصمات · مواد"}] },
  "EV-02": { media_type: "cctv_clip", camera_id:"VLA-01", camera_label:"مدخل الفيلا الشمالي",
             date:"—", time_start:"01:22 ص", time_end:"01:35 ص", duration_sec:780, scene:"villa_gate",
             keyframes:[{at:80,label:"شخص يقفز السور"},{at:220,label:"يعبر الحديقة"},{at:500,label:"يخرج بحقيبة"}],
             note:"لباس أسود · دون قناع كامل." },
  "EV-03": { media_type: "audio", label:"إنذار داخلي — لحظة الاختراق", duration_sec:12, waveform_seed:404,
             voice:{rate:1.0,pitch:1.0},
             transcript_lines:[
               {s:1,t:"[صافرة إنذار خافتة]"},
               {s:5,t:"[صوت زجاج]"},
               {s:9,t:"[خطوات سريعة تبتعد]"},
             ], hint:"صوت الزجاج قبل الإنذار — الإنذار متأخر." },
  "EV-04": { media_type: "phone_forensics", device_label:"هاتف موظف الحراسة",
             imei:"359***********", unlocked_at:"—",
             tabs:{ deleted:[
               {at:"قبل يومين", body:"سأترك البوابة الشمالية مفتوحة ٥ دقائق فقط."},
               {at:"قبل يوم",   body:"لا تنسَ حصتي."},
             ]}, hint:"رسائل محذوفة تكشف تواطؤاً داخلياً." },
};

const CASES = {
  "case-001": CASE_001,
  "case-002": CASE_002,
  "case-003": CASE_003,
  "case-004": CASE_004,
  "case-005": CASE_005,
};

export function getEvidenceMedia(caseId, evidenceId) {
  const map = CASES[caseId] || {};
  return map[evidenceId] || null;
}

export function hasRichMedia(caseId, evidenceId) {
  return !!getEvidenceMedia(caseId, evidenceId);
}

export const MEDIA_TYPE_LABELS = {
  photo:            "صورة مسرح جريمة",
  cctv_clip:        "مقطع كاميرا مراقبة",
  audio:            "تسجيل صوتي",
  phone_call:       "مكالمة هاتفية",
  voicemail:        "بريد صوتي",
  document:         "وثيقة",
  phone_forensics:  "تحليل الهاتف",
};
